__turbopack_context__.v({
  "ShowBannersSection": "ShowBannersSection-module__PaSKba__ShowBannersSection",
  "banner": "ShowBannersSection-module__PaSKba__banner",
  "button": "ShowBannersSection-module__PaSKba__button",
  "buttonContainer": "ShowBannersSection-module__PaSKba__buttonContainer",
  "col1": "ShowBannersSection-module__PaSKba__col1",
  "col2": "ShowBannersSection-module__PaSKba__col2",
  "contents": "ShowBannersSection-module__PaSKba__contents",
  "description": "ShowBannersSection-module__PaSKba__description",
  "section": "ShowBannersSection-module__PaSKba__section",
  "title": "ShowBannersSection-module__PaSKba__title",
  "wide": "ShowBannersSection-module__PaSKba__wide",
});
